/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferredUserData } from './ReferredUserData';
import {
    ReferredUserDataFromJSON,
    ReferredUserDataFromJSONTyped,
    ReferredUserDataToJSON,
    ReferredUserDataToJSONTyped,
} from './ReferredUserData';

/**
 * 
 * @export
 * @interface ReferredUsersResponse
 */
export interface ReferredUsersResponse {
    /**
     * 
     * @type {Array<ReferredUserData>}
     * @memberof ReferredUsersResponse
     */
    referredUsersData: Array<ReferredUserData>;
}

/**
 * Check if a given object implements the ReferredUsersResponse interface.
 */
export function instanceOfReferredUsersResponse(value: object): value is ReferredUsersResponse {
    if (!('referredUsersData' in value) || value['referredUsersData'] === undefined) return false;
    return true;
}

export function ReferredUsersResponseFromJSON(json: any): ReferredUsersResponse {
    return ReferredUsersResponseFromJSONTyped(json, false);
}

export function ReferredUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferredUsersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'referredUsersData': ((json['referredUsersData'] as Array<any>).map(ReferredUserDataFromJSON)),
    };
}

export function ReferredUsersResponseToJSON(json: any): ReferredUsersResponse {
    return ReferredUsersResponseToJSONTyped(json, false);
}

export function ReferredUsersResponseToJSONTyped(value?: ReferredUsersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referredUsersData': ((value['referredUsersData'] as Array<any>).map(ReferredUserDataToJSON)),
    };
}

